import { render, staticRenderFns } from "./PersonaFisica.vue?vue&type=template&id=8ff4a614&scoped=true&"
import script from "./PersonaFisica.vue?vue&type=script&lang=js&"
export * from "./PersonaFisica.vue?vue&type=script&lang=js&"
import style0 from "./PersonaFisica.vue?vue&type=style&index=0&id=8ff4a614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff4a614",
  null
  
)

export default component.exports